export enum Boolean {
  TRUE = "S",
  FALSE = "N",
}
